import { render, staticRenderFns } from "./buyerList.vue?vue&type=template&id=d6165b1c&scoped=true&"
import script from "./buyerList.vue?vue&type=script&lang=js&"
export * from "./buyerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6165b1c",
  null
  
)

export default component.exports